import React from 'react';
import { CloseButton } from '@chakra-ui/react';

var DismissAction = function DismissAction(props) {
  var dismissable = props.dismissable,
      onDismiss = props.onDismiss;
  if (!dismissable || typeof onDismiss !== 'function') return null;
  return /*#__PURE__*/React.createElement(CloseButton, {
    className: "chakra-button",
    "data-action": "dismiss",
    size: 'md',
    onClick: onDismiss
  });
};

DismissAction.displayName = "DismissAction";
export { DismissAction };